import { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const motives = {
  m0: null,
  default: css`
    border: 0.1rem solid ${pickColor('borderColorDarkSecondary')};
    border-radius: ${({ theme }) => theme.borderRadius.big};
  `,
  secondary: css``,
};

export type CheckboxMotives = keyof typeof motives;

const pickMotive = (motive: CheckboxMotives) => motives[motive];

export { pickMotive };
